import { useState } from "react";
import { api } from "../lib/apiClient";
import { ExternalLink, Sparkles, CheckCircle2 } from "lucide-react";

/** Legifrance link badge */
export function LegifranceLink({ url, label = "Source Legifrance" }) {
  if (!url) return null;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs text-[#10B981] hover:underline" data-testid="legifrance-link">
      <ExternalLink className="w-3 h-3" /> {label}
    </a>
  );
}

/** Demo Express Jury — 3 scénarios locaux civils (100 % frontend, sans appel API) */
const LOCAL_SCENARIOS = {
  caution: {
    title: "Caution non restituée (850 €)",
    description: "Mon propriétaire refuse de me restituer mon dépôt de garantie de 850 € deux mois après l'état des lieux de sortie conforme.",
    case_type: "bail_litige"
  },
  charges: {
    title: "Régularisation de charges locatives",
    description: "Mon bailleur me réclame 420 € d'arriérés de charges sans fournir le décompte annuel ni les justificatifs obligatoires.",
    case_type: "bail_litige"
  },
  fps: {
    title: "Contestation forfait post-stationnement (FPS)",
    description: "Avis de paiement FPS de 35 € reçu alors que mon ticket de stationnement dématérialisé était en cours de validité.",
    case_type: "amende"
  }
};

export function DemoExpress({ onLoad }) {
  const [scenarios, setScenarios] = useState(null);

  const load = () => {
    setScenarios(LOCAL_SCENARIOS);
  };

  return (
    <div className="mb-6">
      <button onClick={load} className="btn-navy" data-testid="demo-express-btn">
        <Sparkles className="w-4 h-4" /> Démo Express (Test en 1 clic)
      </button>
      {scenarios && (
        <div className="mt-3 grid sm:grid-cols-3 gap-2 fade-up" data-testid="demo-scenarios-grid">
          {Object.entries(scenarios).map(([key, s]) => (
            <button key={key} onClick={() => onLoad(s)} className="j-card text-left hover:border-[#10B981] transition-colors" data-testid={`demo-scenario-${key}`}>
              <div className="font-heading font-black text-sm text-[#1E293B]">{s.title}</div>
              <div className="text-xs text-slate-500 mt-1 line-clamp-2">{s.description.slice(0, 120)}…</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

/** Post-analysis action buttons (LRAR, Cerfa, Kit) */
export function ActionButtons({ caseId, mode = "citizen" }) {
  const items = [
    { key: "lrar_letter", price: "8,99 €", title: "✉️ Envoyer la Mise en Demeure (LRAR)", desc: "Lettre recommandée officielle La Poste/AR24", testid: "action-lrar" },
    { key: "cerfa_pdf", price: "2,99 €", title: "📄 Rapport PDF & Cerfa/AJ pré-rempli", desc: "Dossier complet + formulaire Aide Juridictionnelle", testid: "action-cerfa" },
    { key: "kit_audience", price: "14,99 €", title: "⚖️ Transmettre le Kit d'Audience à un Avocat", desc: "Ou 0 € via votre AJ / Protection Juridique", testid: "action-kit" },
  ];
  return (
    <div className="space-y-3" data-testid="action-buttons">
      {items.map((it) => (
        <a key={it.key} href={caseId ? `/checkout/${it.key}?case_id=${caseId}` : `/checkout/${it.key}`}
           className="block j-card hover:border-[#10B981] transition-colors" data-testid={it.testid}>
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="font-heading font-black text-sm">{it.title}</div>
              <div className="text-xs text-slate-500 mt-1">{it.desc}</div>
            </div>
            <div className="font-heading font-black text-lg text-[#10B981]">{it.price}</div>
          </div>
        </a>
      ))}
    </div>
  );
}
